import { render } from "./App.vue?vue&type=template&id=1d6a235a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1d6a235a&lang=css"

import exportComponent from "/home/timobile/gitlab_gamotions/gamotions-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__